// extracted by mini-css-extract-plugin
export default {"submit":"CreateInterimCareSummaryPage_submit__214M8"};